module.exports = __webpack_public_path__ + "img/problem_fluid_taps.fa2e05cf.svg";